import { API, ApiPrefixes } from "../api";

export const adminLoanApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getPendingLoansRequestss: builder.query({
      query: (page) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/pending?guard=staff&page=${page}&limit=20`,
      }),
      providesTags: (result, error, arg) => [
        { type: "pending-loans-list", id: arg },
      ],
      cacheStrategy: "cache-and-network",
    }),

    getApprovedLoansList: builder.query({
      query: (page) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/approved?guard=staff&page=${page}&limit=20`,
      }),
      // providesTags: "approved-loans-list",
      providesTags: (result, error, arg) => [
        { type: "approved-loans-list", id: arg },
      ],
    }),

    getDeclinedLoansList: builder.query({
      query: (page) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/declined?guard=staff&page=${page}&limit=20`,
      }),
      // providesTags: "declined-loans-list",
      providesTags: (result, error, arg) => [
        { type: "declined-loans-list", id: arg },
      ],
    }),

    getDisbursedLoansList: builder.query({
      query: (page) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/disbursed?guard=staff&page=${page}&limit=20`,
      }),
      // providesTags: "disbursed-loans-list",
      providesTags: (result, error, arg) => [
        { type: "disbursed-loans-list", id: arg },
      ],
    }),

    getPaidLoansList: builder.query({
      query: (page) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/paid?guard=staff&page=${page}&limit=20`,
      }),
      providesTags: (result, error, arg) => [
        { type: "paid-loans-list", id: arg },
      ],
    }),

    createLoanRequest: builder.mutation({
      query: (payload) => ({
        url: ApiPrefixes["loanManagement"] + `/requests/add?guard=staff`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "pending-loans-list" }],
    }),

    loanCalculator: builder.mutation({
      query: (payload) => ({
        url: ApiPrefixes["loanManagement"] + `/calculator?guard=staff`,
        method: "POST",
        body: payload,
      }),
    }),

    approveLoanRequest: builder.mutation({
      query: (requestId) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/${requestId}/approve?guard=staff`,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "pending-loans-list" },
        { type: "approved-loans-list" },
        { type: "declined-loans-list" },
      ],
    }),

    declineLoanRequest: builder.mutation({
      query: ({ requestId, decline_reason }) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/${requestId}/decline?guard=staff`,
        method: "PUT",
        body: { decline_reason: decline_reason },
      }),
      invalidatesTags: [
        { type: "pending-loans-list" },
        { type: "declined-loans-list" },
      ],
    }),

    disburseRequestedLoan: builder.mutation({
      query: (payload) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/${payload.requestId}/disburse?guard=staff`,
        method: "PUT",
        body: payload.payload,
      }),
      invalidatesTags: [
        { type: "disbursed-loans-list" },
        { type: "approved-loans-list" },
        { type: "member-loan-summary" }, // Invalidate member loan summary when loan is disbursed
        { type: "member-upcoming-repayment-list" }, // Invalidate upcoming repayments
        { type: "member-due-repayment-list" }, // Invalidate due repayments
        { type: "member-overdue-repayment-list" }, // Invalidate overdue repayments
        { type: "member-transaction-history" }, // Invalidate transaction history to show loan disbursement
        { type: "member-disbursed-loans-list" }, // Invalidate disbursed loans list
        { type: "member-dashboard" }, // Invalidate member dashboard (shows financial summary)
        "StaffDashboard",
      ],
    }),

    getDefaultLoanModel: builder.query({
      query: () => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/settings/default-loan-model?guard=staff`,
      }),
      transformResponse: (responseData) => responseData?.data ?? null,
      providesTags: [{ type: "loan-types-list" }],
    }),

    getLoanTypes: builder.query({
      query: ({ page }) => ({
        url: ApiPrefixes["loanManagement"] + `/types?guard=staff&page=${page}`,
      }),
      // providesTags: "loan-types-list",
      providesTags: (result, error, arg) => [
        { type: "loan-types-list", id: arg?.page },
      ],
    }),

    getSelectableLoanTypes: builder.query({
      query: () => ({
        url: ApiPrefixes["adminSelectables"] + `/loan-settings?guard=staff`,
      }),
      // providesTags: "loan-types-list",
      providesTags: (result, error, arg) => [
        { type: "selectable-loan-types-list", id: arg },
      ],
    }),

    getBorrowingEligibility: builder.query({
      query: ({ memberId, loanTypeId }) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/borrowing-eligibility?guard=staff&member_id=${memberId}&loan_type_id=${loanTypeId}`,
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        {
          type: "borrowing-eligibility",
          id: `${arg?.memberId}-${arg?.loanTypeId}`,
        },
      ],
    }),

    createLoanType: builder.mutation({
      query: (payload) => ({
        url: ApiPrefixes["loanManagement"] + `/types/add?guard=staff`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [
        { type: "loan-types-list" },
        { type: "selectable-loan-types-list" },
      ],
    }),

    editLoanType: builder.mutation({
      query: ({ payload, loanTypeId }) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/types/${loanTypeId}/edit?guard=staff`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [
        { type: "loan-types-list" },
        { type: "selectable-loan-types-list" },
      ],
    }),

    deleteLoanType: builder.mutation({
      query: ({ loanTypeId }) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/types/${loanTypeId}/delete?guard=staff`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "loan-types-list" }],
    }),

    getCompanyLoanTypes: builder.query({
      query: () => ({
        url: ApiPrefixes["loanManagement"] + `/types/company?guard=staff`,
      }),
      transformResponse: (responseData) => responseData?.data || [],
      providesTags: (result, error, arg) => [
        { type: "company-loan-types-list", id: arg },
      ],
    }),

    importLoanTypes: builder.mutation({
      query: (payload) => ({
        url: ApiPrefixes["loanManagement"] + `/types/import?guard=staff`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [
        { type: "loan-types-list" },
        { type: "selectable-loan-types-list" },
      ],
    }),

    getGuarantors: builder.query({
      query: () => ({
        url: ApiPrefixes["loanManagement"] + `/guarantors?guard=staff`,
      }),
      providesTags: (result, error, arg) => [
        { type: "guarantors-list", id: arg },
      ],
    }),

    getLoanRequestDetails: builder.query({
      query: (requestId) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/${requestId}/view?guard=staff`,
      }),
      transformResponse: (responseData) => {
        return responseData.data;
      },
      providesTags: (result, error, arg) => [
        { type: "loan-request-details", id: arg },
      ],
    }),

    getGuarantorDetails: builder.query({
      query: (guarantorToken) => ({
        url: `/loans/guarantor/details/${guarantorToken}`,
        method: "GET",
      }),
      transformResponse: (responseData) => {
        return responseData.data;
      },
    }),

    confirmGuarantor: builder.mutation({
      query: (guarantorToken) => ({
        url: `/loans/guarantor/confirm/${guarantorToken}`,
        method: "POST",
      }),
    }),

    declineGuarantor: builder.mutation({
      query: (guarantorToken) => ({
        url: `/loans/guarantor/decline/${guarantorToken}`,
        method: "POST",
      }),
    }),

    resendGuarantorInvitations: builder.mutation({
      query: (requestId) => ({
        url: ApiPrefixes["loanManagement"] + `/requests/${requestId}/resend-guarantor-invitations?guard=staff`,
        method: "POST",
      }),
      invalidatesTags: [{ type: "pending-loans-list" }],
    }),

    removeGuarantor: builder.mutation({
      query: ({ requestId, guarantorId }) => ({
        url: ApiPrefixes["loanManagement"] + `/requests/${requestId}/guarantors/${guarantorId}?guard=staff`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "pending-loans-list" },
        { type: "loan-request-details" },
      ],
    }),

    addGuarantorToLoan: builder.mutation({
      query: ({ requestId, payload }) => ({
        url: ApiPrefixes["loanManagement"] + `/requests/${requestId}/guarantors/add?guard=staff`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [
        { type: "pending-loans-list" },
        { type: "loan-request-details" },
      ],
    }),

    recordExistingLoan: builder.mutation({
      query: (payload) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/record-existing?guard=staff`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [
        { type: "migrated-loans-list" },
        { type: "disbursed-loans-list" },
      ],
    }),

    getMigratedLoans: builder.query({
      query: ({ page = 1, limit = 20, lock_status = "all" } = {}) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/migrated?guard=staff&page=${page}&limit=${limit}&lock_status=${lock_status}`,
      }),
      transformResponse: (responseData) => responseData?.data ?? responseData,
      providesTags: [{ type: "migrated-loans-list", id: "LIST" }],
    }),

    getMigratedLoanDetail: builder.query({
      query: (loanId) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/migrated/${loanId}?guard=staff`,
      }),
      transformResponse: (responseData) => responseData?.data ?? responseData,
      providesTags: (result, error, loanId) => [
        { type: "migrated-loan-detail", id: loanId },
      ],
    }),

    recordMigratedLoanPayment: builder.mutation({
      query: ({ loanId, payload }) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/migrated/${loanId}/payments?guard=staff`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "migrated-loan-detail", id: arg.loanId },
        { type: "migrated-loans-list" },
        { type: "disbursed-loans-list" },
      ],
    }),

    confirmLockMigratedLoan: builder.mutation({
      query: (loanId) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/migrated/${loanId}/confirm-lock?guard=staff`,
        method: "POST",
      }),
      invalidatesTags: (result, error, loanId) => [
        { type: "migrated-loan-detail", id: loanId },
        { type: "migrated-loans-list" },
        { type: "disbursed-loans-list" },
        { type: "upcoming-loan-repayment" },
        { type: "due-loan-repayment" },
        { type: "overdue-loan-repayment" },
        { type: "member-disbursed-loans-list" },
        { type: "member-upcoming-repayment-list" },
        { type: "member-due-repayment-list" },
        { type: "member-overdue-repayment-list" },
        { type: "member-loan-summary" },
      ],
    }),

    deleteMigratedLoanDraft: builder.mutation({
      query: (loanId) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/migrated/${loanId}?guard=staff`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, loanId) => [
        { type: "migrated-loan-detail", id: loanId },
        { type: "migrated-loans-list" },
        { type: "disbursed-loans-list" },
        { type: "upcoming-loan-repayment" },
        { type: "due-loan-repayment" },
        { type: "overdue-loan-repayment" },
        { type: "member-disbursed-loans-list" },
        { type: "member-upcoming-repayment-list" },
        { type: "member-due-repayment-list" },
        { type: "member-overdue-repayment-list" },
        { type: "member-loan-summary" },
      ],
    }),
  }),
});

export const {
  useApproveLoanRequestMutation,
  useDeclineLoanRequestMutation,
  useDisburseRequestedLoanMutation,
  useCreateLoanRequestMutation,
  useLoanCalculatorMutation,
  useGetApprovedLoansListQuery,
  useGetDeclinedLoansListQuery,
  useGetDisbursedLoansListQuery,
  useGetPaidLoansListQuery,
  useGetPendingLoansRequestssQuery,
  useGetDefaultLoanModelQuery,
  useGetLoanTypesQuery,
  useGetSelectableLoanTypesQuery,
  useGetBorrowingEligibilityQuery,
  useCreateLoanTypeMutation,
  useEditLoanTypeMutation,
  useDeleteLoanTypeMutation,
  useGetCompanyLoanTypesQuery,
  useImportLoanTypesMutation,
  useGetGuarantorsQuery,
  useGetLoanRequestDetailsQuery,
  useGetGuarantorDetailsQuery,
  useConfirmGuarantorMutation,
  useDeclineGuarantorMutation,
  useResendGuarantorInvitationsMutation,
  useRemoveGuarantorMutation,
  useAddGuarantorToLoanMutation,
  useRecordExistingLoanMutation,
  useGetMigratedLoansQuery,
  useGetMigratedLoanDetailQuery,
  useRecordMigratedLoanPaymentMutation,
  useConfirmLockMigratedLoanMutation,
  useDeleteMigratedLoanDraftMutation,
} = adminLoanApi;
